// Shared Leaflet boot for the trail + water maps: OSM base tiles and a zoom
// control nudged out of the top toolbar's way.
import { leafletTileConfig } from "../tile_sources"

export function createBaseMap(L, container, { lat, lng, zoom }) {
  const map = L.map(container).setView([lat, lng], zoom)
  map.zoomControl.setPosition("bottomright")
  const streets = leafletTileConfig("streets")
  L.tileLayer(streets.url, streets.options).addTo(map)
  return map
}

// Esri World Imagery — sharp aerial/satellite to z19. Returned un-added so the
// caller toggles it (it sits above OSM, below overlays). Display-only; offline
// packs use public-domain NAIP instead. Note ArcGIS tile order is {z}/{y}/{x}.
export function satelliteLayer(L) {
  const satellite = leafletTileConfig("satellite")
  return L.tileLayer(satellite.url, satellite.options)
}

export function usgsTopoLayer(L, options = {}) {
  const topo = leafletTileConfig("topo", options)
  return L.tileLayer(topo.url, topo.options)
}
